import React from 'react';
import { CalendarView, CalendarSidebar } from 'widgets/CalendarsLayout';
import { ResizableSidebarPageLayout } from 'shared/layouts/pageLevelLayouts';

const CalendarLayoutPage: React.FC = () => {
  return (
    <ResizableSidebarPageLayout sidebar={<CalendarSidebar />}>
      <CalendarView />
    </ResizableSidebarPageLayout>
  );
};

export default CalendarLayoutPage;
